import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from "@mui/material";
import Spinner from '../../Components/spinner/spinner';
import { useState } from "react";
import { Button } from '@mui/material';
import { Modal } from 'react-bootstrap';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import useGst from '../Setting/Hooks/useGst'
import { ToastContainer } from 'react-toastify'
import Paginations from '../../Components/Pagination/pagination'

const Gst = () => {
  const navigate = useNavigate()

  const {
    listGst,
    formData,
    handleChange,
    setShow, setShowModal, show, showModal, createGstApi, deleteGstApi, updateGstApi,
    mode,
    openAddModal,
    openEditModal,
    submitGst,
    isSaving,
    changeStatusGstApi,
    setPage,
    count,
    setCount,
    PER_PAGE,
    page,
    spinner
  } = useGst()

  return (
    <section>
      <ToastContainer />
      <div className="m-t-3 cus-padd cusheight">
        {spinner ? <Spinner /> : null}
        <header>
          <h2 className='page-tittle'><i className="fa-solid fa-angle-left cusgap cursor" onClick={() => navigate(-1)}></i>GST</h2>
          <hr />
        </header>
        <div className="d-flex justify-content-end">

          <button onClick={() => openAddModal('add')} type="button" className="btn yesbtn" >
            Add Gst
          </button>
        </div>
        <div className="table-responsive">
          <table className="table cus-table">
            <thead className="text-center tableheader">
              <tr>
                <th scope="col">Gst (%)</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {listGst?.map((item) => (

                <tr key={item._id} id={item._id} className="text-center">
                  <td style={{ padding: '0.4rem .5rem' }}>{item.gst}</td>
                  <td>
                    <span className="d-flex justify-content-center">

                      <span className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" checked={item?.isActive} onChange={(e) => changeStatusGstApi(item._id, item.isActive)} />
                      </span>
                    </span>
                  </td>

                  {/* <td style={{ padding: '0.4rem .5rem' }}>  <FormControlLabel control={<Switch  className="form-check-input"  onChange={(e) => changeStatusGstApi(item._id, item.isActive)}   checked={item?.isActive} />} /></td> */}
                  <td style={{ padding: '0.4rem .5rem' }}>
                    <Button color="primary" onClick={() => openEditModal(item)}><EditIcon /></Button>
                    <Button color="warning" onClick={() => deleteGstApi(item._id)}><DeleteIcon /></Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className='w-100 d-flex justify-content-center'>
            {listGst?.length === 0 ? null :
              count > 10 &&
              <Paginations setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />
            }
          </div>
        </div>
      </div>
      <Modal centered show={showModal} onHide={() => setShowModal(false)}>
        <div className="modal-body">
          <h6 className="text-center">{mode === 'add' ? 'Add GST' : 'Update GST'}</h6>
          <div className="py-3">
            <div className="cus-form">

              <label htmlFor="">Gst</label> <br />

              <input type="text" className="form-control w-100" placeholder="" name="gst" onChange={handleChange} value={formData.gst} />
            </div>
          </div>

          <div className="d-flex gap-4">
            <button type="button" className="btn yesbtn" data-bs-dismiss="modal" onClick={() => setShowModal(false)}>
              No
            </button>
            <button
              type="button"
              className="btn yesbtn"
              onClick={submitGst}
              disabled={isSaving}
            >
              {mode === 'add' ? 'Add' : 'Update'}
            </button>

          </div>
        </div>
      </Modal>
    </section>
  )
}

export default Gst;